import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
  Progress,
  CardImg,
  Button,
  UncontrolledTooltip,
  Form,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
  Badge,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  CardHeader,
  Label,
} from "reactstrap";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { Link } from "react-router-dom";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

import { api } from "../../../../api";

import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom/dist";
import Cookies from "js-cookie";

const Wasteage4 = () => {
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [onTime, setOnTime] = useState(0);
  const [late, setLate] = useState(0);
  const [leaves, setLeaves] = useState(0);

  const navigate = useNavigate();

  const [ViewProjectName, setViewProjectName] = useState("");
  const [showViewConfirmation, setShowViewConfirmation] = useState(false);

  const [deleteProjectName, setDeleteProjectName] = useState("");

  // For Maintenance List (Replaced Items)
  const [searchQueryReplace, setSearchQueryReplace] = useState("");

  // For Waste Details
  const [searchQueryWaste, setSearchQueryWaste] = useState("");

  const allData = [
    {
      slNo: 1,
      wastedItems: 10,
      replacedItems: 20,
      costSpent: 3000,
      wasteIncome: 1500,
    },
    {
      slNo: 2,
      wastedItems: 8,
      replacedItems: 25,
      costSpent: 3500,
      wasteIncome: 1800,
    },
    {
      slNo: 3,
      wastedItems: 15,
      replacedItems: 18,
      costSpent: 2800,
      wasteIncome: 1300,
    },
    {
      slNo: 4,
      wastedItems: 12,
      replacedItems: 22,
      costSpent: 3200,
      wasteIncome: 1600,
    },
    {
      slNo: 5,
      wastedItems: 9,
      replacedItems: 21,
      costSpent: 3100,
      wasteIncome: 1400,
    },
    {
      slNo: 6,
      wastedItems: 11,
      replacedItems: 23,
      costSpent: 3300,
      wasteIncome: 1700,
    },
    {
      slNo: 7,
      wastedItems: 14,
      replacedItems: 19,
      costSpent: 2900,
      wasteIncome: 1200,
    },
    {
      slNo: 8,
      wastedItems: 13,
      replacedItems: 24,
      costSpent: 3400,
      wasteIncome: 1500,
    },
    {
      slNo: 9,
      wastedItems: 16,
      replacedItems: 17,
      costSpent: 2700,
      wasteIncome: 1100,
    },
    {
      slNo: 10,
      wastedItems: 18,
      replacedItems: 16,
      costSpent: 2600,
      wasteIncome: 1000,
    },
    {
      slNo: 11,
      wastedItems: 20,
      replacedItems: 15,
      costSpent: 2500,
      wasteIncome: 900,
    },
    {
      slNo: 12,
      wastedItems: 19,
      replacedItems: 14,
      costSpent: 2400,
      wasteIncome: 800,
    },
    {
      slNo: 13,
      wastedItems: 17,
      replacedItems: 13,
      costSpent: 2300,
      wasteIncome: 700,
    },
    {
      slNo: 14,
      wastedItems: 16,
      replacedItems: 12,
      costSpent: 2200,
      wasteIncome: 600,
    },
    {
      slNo: 15,
      wastedItems: 14,
      replacedItems: 11,
      costSpent: 2100,
      wasteIncome: 500,
    },
    {
      slNo: 16,
      wastedItems: 12,
      replacedItems: 10,
      costSpent: 2000,
      wasteIncome: 400,
    },
    {
      slNo: 17,
      wastedItems: 10,
      replacedItems: 9,
      costSpent: 1900,
      wasteIncome: 300,
    },
    {
      slNo: 18,
      wastedItems: 8,
      replacedItems: 8,
      costSpent: 1800,
      wasteIncome: 200,
    },
    {
      slNo: 19,
      wastedItems: 6,
      replacedItems: 7,
      costSpent: 1700,
      wasteIncome: 100,
    },
    {
      slNo: 20,
      wastedItems: 4,
      replacedItems: 6,
      costSpent: 1600,
      wasteIncome: 0,
    },
  ];

  const [replacedata, setreplacedata] = useState([]);
  const [wastecount, setwastecount] = useState();
  const [wastedata, setwastedata] = useState([]); // Initialize as empty array

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const company_id = Cookies.get('company_id');
        const response = await api.get(`wasteitemaddSTM.php?repalce='replace'&company_id=${company_id}`);
        setreplacedata(Array.isArray(response.data) ? response.data : []);
        const response2 = await api.post('wasteCount.php', { company_id });
        setwastecount(response2.data);
        const response3 = await api.get(`wasteitemaddSTM.php?waste='waste'&company_id=${company_id}`);
        setwastedata(Array.isArray(response3.data) ? response3.data : []);
        setLoading(false);
        console.log(wastecount?.data?.replacement?.count);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const [showRoleModal, setShowRoleModal] = useState(false);

  // const toggleRole = () => {
  //     setShowRoleModal(!showRoleModal);
  // };

  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  // Add searchQuery as dependency

  // const [role, setrole] = useState();

  // const handleInputChange = (e) => {
  //     const { name, value } = e.target;
  //     setrole((prevState) => ({
  //         ...prevState,
  //         [name]: value,
  //     }));

  //     console.log(role)
  // };

  const [type, settype] = useState();

  const [sendWastedata, setsendWastedata] = useState({
    waste_type: type,
    itemwaste: "",
    wasteimage: "",
  });

  useEffect(() => {
    setsendWastedata({
      ...sendWastedata,
      waste_type: type,
    });
  }, [type]);

  const handleInputChange1 = (e) => {
    const { name, value } = e.target;
    setsendWastedata((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    console.log(sendWastedata);
  };

  const handleFileChange1 = (e) => {
    const { name } = e.target;
    const file = e.target.files[0];
    setsendWastedata((prevState) => ({
      ...prevState,
      [name]: file,
    }));
    console.log(sendWastedata);
  };

  const [sendReplacedata, setsendReplacedata] = useState({
    waste_type: type,
    replaceItemName: "",
    replaceImage: null,
    costSpent: "",
    revenue: "",
    newreplaceImage: null,
  });

  useEffect(() => {
    setsendReplacedata({
      ...sendReplacedata,
      waste_type: type,
    });
  }, [type]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setsendReplacedata((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    console.log(sendReplacedata);
  };

  const handleFileChange = (e) => {
    const { name } = e.target;
    const file = e.target.files[0];
    setsendReplacedata((prevState) => ({
      ...prevState,
      [name]: file,
    }));
  };

  // Success and error alert states
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // Track missing fields for highlighting
  const [missingFields, setMissingFields] = useState([]);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    let data = null;
    const company_id = Cookies.get('company_id');
    if (type === "waste") {
      // Validate required fields for waste
      if (!sendWastedata.itemwaste || !sendWastedata.wasteimage) {
        setErrorMessage("Please fill all required fields for Damaged Item and upload an image.");
        setShowErrorAlert(true);
        setMissingFields([!sendWastedata.itemwaste ? 'itemwaste' : null, !sendWastedata.wasteimage ? 'wasteimage' : null].filter(Boolean));
        return;
      }
      setMissingFields([]);
      const formdatawaste = new FormData();
      formdatawaste.append("waste_type", sendWastedata.waste_type);
      formdatawaste.append("itemwaste", sendWastedata.itemwaste);
      formdatawaste.append("wasteimage", sendWastedata.wasteimage);
      formdatawaste.append("company_id", company_id);
      data = formdatawaste;
    } else {
      // Validate required fields for replace
      const missing = [];
      if (!sendReplacedata.replaceItemName) missing.push('replaceItemName');
      if (!sendReplacedata.replaceImage) missing.push('replaceImage');
      if (!sendReplacedata.costSpent) missing.push('costSpent');
      if (!sendReplacedata.newreplaceImage) missing.push('newreplaceImage');
      if (!sendReplacedata.revenue) missing.push('revenue');
      if (missing.length > 0) {
        setErrorMessage("Please fill all required fields for Replace Item and upload both images.");
        setShowErrorAlert(true);
        setMissingFields(missing);
        return;
      }
      setMissingFields([]);
      const formdatareplace = new FormData();
      formdatareplace.append("waste_type", sendReplacedata.waste_type);
      formdatareplace.append("replaceItemName", sendReplacedata.replaceItemName);
      formdatareplace.append("replaceImage", sendReplacedata.replaceImage);
      formdatareplace.append("costSpent", sendReplacedata.costSpent);
      formdatareplace.append("newreplaceImage", sendReplacedata.newreplaceImage);
      formdatareplace.append("revenue", sendReplacedata.revenue);
      formdatareplace.append("company_id", company_id);
      data = formdatareplace;
    }

    try {
      const response = await api.post(`wasteitemaddSTM.php`, data);
      if (response.data && response.data.status === "success") {
        setSuccessMessage("Item added successfully!");
        setShowSuccessAlert(true);
        // Optionally, refresh data here instead of reloading the page
        // fetchData();
      } else {
        setErrorMessage(response.data && response.data.message ? response.data.message : "Error adding item.");
        setShowErrorAlert(true);
      }
    } catch (error) {
      setErrorMessage("Error submitting data. Please try again.");
      setShowErrorAlert(true);
      console.error("Error submitting data:", error);
    }
  };

  const toggleDropdown = (index) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  // Pgination code from here
  const [projectDropdownOpen, setProjectDropdownOpen] = useState(false);
  const [entriesToShow, setEntriesToShow] = useState(5); // State variable for selected number of entries
  const [dataToShow, setDataToShow] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [showWasteFields, setShowWasteFields] = useState(false);
  const [showReplaceFields, setShowReplaceFields] = useState(false);
  const [View1ProjectName, setView1ProjectName] = useState("");

  useEffect(() => {
    setDataToShow(
      allData.slice(
        (currentPage - 1) * entriesToShow,
        currentPage * entriesToShow
      )
    );
  }, [entriesToShow, currentPage, allData.length]);

  const toggleProjectDropdown = () => {
    setProjectDropdownOpen(!projectDropdownOpen);
  };

  const handleEntriesChange = (value) => {
    setEntriesToShow(Number(value));
  };

  const handleDropdownToggle = (index) => {
    setDataToShow((prevData) => {
      const newData = [...prevData];
      newData[index].dropdownOpen = !newData[index].dropdownOpen;
      return newData;
    });
  };

  const prePage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const nextPage = () => {
    if (currentPage < Math.ceil(allData.length / entriesToShow)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const changeCPage = (n) => {
    setCurrentPage(n);
  };

  const handleDownload = () => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const fileName = "replace_item_list";

    // Convert dataToShow to the format needed for XLSX.utils.json_to_sheet
    const formattedData = replacedata.map((item, index) => ({
      "Sl.No": ++index,
      "Replaced Items": item.replace_item_name,
      "Cost Spent": item.cost,
      "Waste Income": item.revenue_generated,
      "Image Link": item.replace_item_image, // Assuming 'replace_item_image' contains the image URL
    }));

    // Create a worksheet
    const ws = XLSX.utils.json_to_sheet(formattedData, {
      header: [
        "Sl.No",
        "Replaced Items",
        "Cost Spent",
        "Waste Income",
        "Image Link",
      ],
    });

    // Create a workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Waste List");

    // Apply bold and background color to headers
    const headerCellStyle = {
      font: { bold: true },
      fill: { bgColor: { indexed: 64 } },
    };
    Object.keys(ws)
      .filter((key) => key.startsWith("A1"))
      .forEach((key) => {
        ws[key].s = headerCellStyle;
      });

    // Convert the workbook to a binary Excel file
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    // Create a Blob from the Excel buffer
    const excelData = new Blob([excelBuffer], { type: fileType });

    // Create a URL for the Blob
    const excelUrl = URL.createObjectURL(excelData);

    // Create a link and trigger the download
    const link = document.createElement("a");
    link.href = excelUrl;
    link.download = fileName + fileExtension;
    document.body.appendChild(link);
    link.click();

    // Cleanup
    setTimeout(function () {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(excelUrl);
    }, 100);
  };

  const getSerialNumber = (index) => {
    return (currentPage - 1) * entriesToShow + index + 1;
  };

  const toggleRole = () => {
    setShowRoleModal(!showRoleModal);
    setShowWasteFields(false); // Close waste fields when modal toggles
    setShowReplaceFields(false); // Close replace fields when modal toggles
  };

  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);

  const handleDeleteClick = (itemId) => {
    setSelectedItemId(itemId);
    setShowDeleteConfirmation(true);
  };

  // Success alert for deletion
  const [showDeleteSuccessAlert, setShowDeleteSuccessAlert] = useState(false);
  const [deleteSuccessMessage, setDeleteSuccessMessage] = useState("");

  const handleDeleteConfirmation = () => {
    const company_id = Cookies.get('company_id');
    const data = {
      id: deleteProjectName,
      waste_type: "replace",
      company_id: company_id
    };
    console.log('Delete payload:', data);
    const fetchData = async () => {
      try {
        const response = await api.post(`wasteitemdeleteSTM.php`, data);
        console.log(response.data);
        if (response.data && response.data.status === "success") {
          setDeleteSuccessMessage("Replacement item deleted successfully!");
          setShowDeleteSuccessAlert(true);
        } else {
          // fallback: reload if not success, or you can show error
          window.location.reload();
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        window.location.reload();
      }
    };
    fetchData();
    setShowDeleteConfirmation(false);
  };

  const [projectDropdownOpen1, setProjectDropdownOpen1] = useState(false);

  const toggleProjectDropdown1 = () => {
    setProjectDropdownOpen1(!projectDropdownOpen1);
  };

  const handleEntriesChange1 = (value) => {
    setEntriesToShow1(Number(value));
  };

  const [entriesToShow1, setEntriesToShow1] = useState(10); // State variable for selected number of entries
  const [dataToShow1, setDataToShow1] = useState([]);
  const [currentPage1, setCurrentPage1] = useState(1);
  const [showView1Confirmation, setShowView1Confirmation] = useState(false);
  const [delete1ProjectName, setDelete1ProjectName] = useState("");
  const [showDelete1Confirmation, setShowDelete1Confirmation] = useState(false);

  const allData1 = [
    { hello: "1", world: "Image1" },
    { hello: "2", world: "Image2" },
    { hello: "3", world: "Image3" },
    { hello: "4", world: "Image4" },
    { hello: "5", world: "Image5" },
    { hello: "6", world: "Image6" },
  ];

  const handleView1Confirmation = () => {
    console.log("View");
    setShowView1Confirmation(false);
  };

  const [wastedelete, setwastedelete] = useState();
  const handleDelete1Confirmation = () => {
    const company_id = Cookies.get('company_id');
    const data = {
      id: wastedelete,
      waste_type: "waste",
      company_id: company_id
    };
    console.log('Delete payload:', data);
    const fetchData = async () => {
      try {
        const response = await api.post(`wasteitemdeleteSTM.php`, data);
        console.log(response.data);
        if (response.data && response.data.status === "success") {
          setDeleteSuccessMessage("Waste item deleted successfully!");
          setShowDeleteSuccessAlert(true);
        } else {
          window.location.reload();
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        window.location.reload();
      }
    };
    fetchData();
    setShowDelete1Confirmation(false);
  };

  const prePage1 = () => {
    if (currentPage1 > 1) {
      setCurrentPage1(currentPage1 - 1);
    }
  };

  const nextPage1 = () => {
    if (currentPage1 < Math.ceil(allData1.length / entriesToShow1)) {
      setCurrentPage1(currentPage1 + 1);
    }
  };

  const changeCPage1 = (n) => {
    setCurrentPage1(n);
  };

  const filteredReplaceData = replacedata
    ? replacedata.filter((item) =>
        item.replace_item_name
          ?.toLowerCase()
          .includes(searchQueryReplace.toLowerCase())
      )
    : [];

  const filteredWasteData = wastedata
    ? wastedata.filter((item) =>
        item.item_name?.toLowerCase().includes(searchQueryWaste.toLowerCase())
      )
    : [];

  return (
    <div className="header bg-gradient-info py-7 py-lg-8">
      <Container fluid>
        <Row className="d-flex justify-content-center align-items-center">
  {/* Total Wastes */}
  <Col lg="6" xl="3" className="mb-3">
    <Card
      className="card-stats mb-4 mb-xl-0"
      style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px' }}
    >
      <CardBody>
        <div className="d-flex justify-content-between align-items-center">
          <CardTitle className="h4 mb-0">Total Wastes</CardTitle>
          <span className="h2 font-weight-bold">
            {wastecount?.data?.waste?.count ?? 0}
          </span>
        </div>
      </CardBody>
    </Card>
  </Col>

  {/* Replaced Items */}
  <Col lg="6" xl="3" className="mb-3">
    <Card
      className="card-stats mb-4 mb-xl-0"
      style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px' }}
    >
      <CardBody>
        <div className="d-flex justify-content-between align-items-center">
          <CardTitle className="h4 mb-0">Replaced Items</CardTitle>
          <span className="h2 font-weight-bold">
            {wastecount?.data?.replacement?.count ?? 0}
          </span>
        </div>
      </CardBody>
    </Card>
  </Col>

  {/* Revenue Generated */}
  <Col lg="6" xl="3" className="mb-3">
    <Card
      className="card-stats mb-4 mb-xl-0"
      style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px' }}
    >
      <CardBody>
        <div className="d-flex justify-content-between align-items-center">
          <CardTitle className="h4 mb-0">Revenue Generated</CardTitle>
          <span className="h2 font-weight-bold">
            {wastecount?.data?.replacement?.amount ?? 0}
          </span>
        </div>
      </CardBody>
    </Card>
  </Col>
</Row>

        <div className="mt-5">
          <Row className="mb-5">
            <Col className="order-xl-2 mb-5 mb-xl-0 d-flex ">
              <Form className="navbar-search  form-inline ml-5 d-md-flex ml-lg-auto ">
                <FormGroup className="mb-0 ">
                  
                </FormGroup>
              </Form>
              <Button className="ml-4" style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black' }} onClick={toggleRole}>
                Add New Waste
              </Button>
            </Col>
          </Row>

          <Modal isOpen={showRoleModal} toggle={toggleRole}>
            <ModalHeader toggle={toggleRole}>
              <h2 style={{ fontWeight: "bolder", textTransform: "uppercase" }}>
                New Waste
              </h2>
            </ModalHeader>
            <ModalBody>
              <Form onSubmit={handleFormSubmit}>
                <Row>
                  <Col md={12}>
                    <FormGroup check>
                      <Input
                        type="checkbox"
                        id="wasteCheckbox"
                        checked={showWasteFields}
                        onChange={() => {
                          settype("waste");
                          setShowWasteFields(true);
                          setShowReplaceFields(false);
                        }}
                      />
                      <Label check for="wasteCheckbox">
                        Damaged
                      </Label>
                    </FormGroup>
                    {showWasteFields && (
                      <>
                        <FormGroup>
                          <Label
                            className="form-control-label"
                            htmlFor="input-waste-item-name"
                          >
                            Damaged Item Name
                          </Label>
                          <Input
                            className="form-control-alternative"
                            id="input-waste-item-name"
                            type="text"
                            name="itemwaste"
                            onChange={handleInputChange1}
                            placeholder="Enter Damaged Item Name"
                          />
                        </FormGroup>
                        <FormGroup>
                          <Label
                            className="form-control-label"
                            htmlFor="input-waste-image"
                          >
                            Upload Damaged Image
                          </Label>
                          <Input
                            className="form-control-alternative"
                            id="input-waste-image"
                            type="file"
                            name="wasteimage"
                            onChange={handleFileChange1}
                          />
                        </FormGroup>
                      </>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <FormGroup check>
                      <Input
                        type="checkbox"
                        id="replaceCheckbox"
                        checked={showReplaceFields}
                        onChange={() => {
                          setShowWasteFields(false);
                          setShowReplaceFields(true);
                          settype("replace");
                        }}
                      />
                      <Label check for="replaceCheckbox">
                        Replace
                      </Label>
                    </FormGroup>
                    {showReplaceFields && (
                      <>
                        <FormGroup>
                          <Label
                            className="form-control-label"
                            htmlFor="input-replace-item-name"
                          >
                            Replace Item Name
                          </Label>
                          <Input
                            className="form-control-alternative"
                            id="input-replace-item-name"
                            type="text"
                            name="replaceItemName"
                            onChange={handleInputChange}
                            placeholder="Enter Name of the item to be replaced"
                            style={missingFields.includes('replaceItemName') ? { border: '2px solid #d9534f' } : {}}
                          />
                        </FormGroup>
                        <FormGroup>
                          <Label
                            className="form-control-label"
                            htmlFor="input-cost-spent"
                          >
                            Enter Cost Spent
                          </Label>
                          <Input
                            className="form-control-alternative"
                            id="input-cost-spent"
                            type="number"
                            name="costSpent"
                            onChange={handleInputChange}
                            placeholder="Enter the Cost"
                            style={missingFields.includes('costSpent') ? { border: '2px solid #d9534f' } : {}}
                          />
                        </FormGroup>
                        <FormGroup>
                          <Label
                            className="form-control-label"
                            htmlFor="input-replace-image"
                          >
                            Upload Replaced Item Image
                          </Label>
                          <Input
                            className="form-control-alternative"
                            id="input-replace-image"
                            type="file"
                            name="replaceImage"
                            onChange={handleFileChange}
                            style={missingFields.includes('replaceImage') ? { border: '2px solid #d9534f' } : {}}
                          />
                        </FormGroup>
                        <hr />

                        <FormGroup>
                          <Label
                            className="form-control-label"
                            htmlFor="input-cost-spent"
                          >
                            Enter the Revenue Generated from Waste
                          </Label>
                          <Input
                            className="form-control-alternative"
                            id="input-cost-spent"
                            type="number"
                            name="revenue"
                            onChange={handleInputChange}
                            placeholder="Enter the Cost"
                            style={missingFields.includes('revenue') ? { border: '2px solid #d9534f' } : {}}
                          />
                        </FormGroup>

                        <FormGroup>
                          <Label
                            className="form-control-label"
                            htmlFor="input-replace-image"
                          >
                            Upload The Image Of New Item
                          </Label>
                          <Input
                            className="form-control-alternative"
                            id="input-replace-image"
                            type="file"
                            name="newreplaceImage"
                            onChange={handleFileChange}
                            style={missingFields.includes('newreplaceImage') ? { border: '2px solid #d9534f' } : {}}
                          />
                        </FormGroup>
                      </>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col lg="12" style={{ textAlign: "center" }}>
                    <Button style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black' }} type="submit">
                      Submit
                    </Button>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </div>
        <React.Fragment>
          <Row className="mt-5">
            <Col className="mb-5 mb-xl-0" xl="12">
              <Card className="" style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px' }}>
                <CardBody>
                  <CardHeader className="border-0">
                    <Row className="align-items-center">

  {/* Header - visible for all */}
 <div className="col-12 text-center mb-3 d-block d-lg-none">
  <h3 className="mb-0 font-bold">Replacement Items List</h3>
</div>

  {/* Mobile & Tablet View (< 1024px) */}
  <div className="col-12 d-lg-none">
  {/* Dropdown (left) + Button (right) in same row with full spacing */}
  <div className="d-flex justify-content-between align-items-center mb-3 w-100">
    {/* Dropdown aligned to start */}
    <div className="flex-grow-1" style={{ maxWidth: '48%',marginRight:'60px' }}>
      <Dropdown isOpen={projectDropdownOpen} toggle={toggleProjectDropdown}>
        <DropdownToggle
          caret
          className="w-100 text-left p-2"
          style={{ fontSize: '14px' }}
        >
          Show Entries:{" "}
          {entriesToShow === (replacedata ? replacedata.length : 0)
            ? "All"
            : entriesToShow}
        </DropdownToggle>
        <DropdownMenu className="w-100">
          <DropdownItem onClick={() => setEntriesToShow(5)}>5</DropdownItem>
          <DropdownItem onClick={() => setEntriesToShow(10)}>10</DropdownItem>
          <DropdownItem
            onClick={() =>
              setEntriesToShow(replacedata ? replacedata.length : 0)
            }
          >
            All
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>

    {/* Spacer (invisible but forces space) */}
    <div style={{ width: '4%' }} />

    {/* Button aligned to end */}
    <div className="flex-grow-1" style={{ maxWidth: '48%' }}>
      <button
        className="btn btn-success w-100 p-2"
        onClick={handleDownload}
        style={{
          backgroundColor: '#d86f89',
          borderColor: '#d86f89',
          color: 'black',
          fontSize: '14px',
        }}
      >
        Download
      </button>
    </div>
  </div>

  {/* Search Bar Below */}
  <InputGroup
    className="input-group-alternative mb-3"
    style={{
      width: '100%',
      border: '2px solid #1e3a8a', // Tailwind's blue-900
      borderRadius: '18px',
      overflow: 'hidden', // Ensures children respect border radius
      background: '#fff'
    }}
  >
    <InputGroupAddon addonType="prepend">
      <InputGroupText style={{ background: 'transparent', border: 'none' }}>
        <i className="fas fa-search" style={{ color: 'black' }} />
      </InputGroupText>
    </InputGroupAddon>
    <Input
      placeholder="Search Replaced Items"
      type="text"
      value={searchQueryReplace}
      onChange={(e) => setSearchQueryReplace(e.target.value)}
      style={{
        border: 'none',
        boxShadow: 'none',
        background: 'transparent'
      }}
    />
  </InputGroup>
</div>


  {/* Laptop View (lg only, = 1024px) */}
  <div className="col-12 d-none d-lg-flex d-xl-none flex-column">
    <div className="text-center mb-3">
      <h3 className="mb-0 font-bold">Replacement Items List</h3>
    </div>
    <div className="d-flex justify-content-between align-items-center">
      {/* Dropdown */}
      <Dropdown isOpen={projectDropdownOpen} toggle={toggleProjectDropdown}>
        <DropdownToggle caret>
          Show Entries:{" "}
          {entriesToShow === (replacedata ? replacedata.length : 0)
            ? "All"
            : entriesToShow}
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={() => setEntriesToShow(5)}>5</DropdownItem>
          <DropdownItem onClick={() => setEntriesToShow(10)}>10</DropdownItem>
          <DropdownItem
            onClick={() =>
              setEntriesToShow(replacedata ? replacedata.length : 0)
            }
          >
            All
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>

      {/* Search Bar */}
      <InputGroup
        className="input-group-alternative mx-3"
        style={{ width: 220,border: '2px solid #1e3a8a', // Tailwind's blue-900
           }}
      >
        <InputGroupAddon addonType="prepend">
          <InputGroupText>
            <i className="fas fa-search " style={{ color: 'black' }} />
          </InputGroupText>
        </InputGroupAddon>
        <Input
          placeholder="Search Replaced Items"
          type="text"
          value={searchQueryReplace}
          onChange={(e) => setSearchQueryReplace(e.target.value)}
        />
      </InputGroup>

      {/* Button */}
      <button
        className="btn btn-success"
        onClick={handleDownload}
        style={{
          backgroundColor: '#d86f89',
          borderColor: '#d86f89',
          color: 'black',
        }}
      >
        Download
      </button>
    </div>
  </div>

  {/* Desktop View (≥ xl) - all in one row */}
  <div className="col d-none d-xl-flex justify-content-between align-items-center">
    {/* Header */}
    <h3 className="mb-0 font-bold">Replacement Items List</h3>

    {/* Search */}
    <InputGroup
      className="input-group-alternative"
      style={{ width: 220, border: '2px solid #1e3a8a', // Tailwind's blue-900
         }}
    >
      <InputGroupAddon addonType="prepend">
        <InputGroupText>
          <i className="fas fa-search" style={{ color: 'black' }} />
        </InputGroupText>
      </InputGroupAddon>
      <Input
        placeholder="Search Replaced Items"
        type="text"
        value={searchQueryReplace}
        onChange={(e) => setSearchQueryReplace(e.target.value)}
      />
    </InputGroup>

    {/* Dropdown */}
    <Dropdown isOpen={projectDropdownOpen} toggle={toggleProjectDropdown}>
      <DropdownToggle caret>
        Show Entries:{" "}
        {entriesToShow === (replacedata ? replacedata.length : 0)
          ? "All"
          : entriesToShow}
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem onClick={() => setEntriesToShow(5)}>5</DropdownItem>
        <DropdownItem onClick={() => setEntriesToShow(10)}>10</DropdownItem>
        <DropdownItem
          onClick={() =>
            setEntriesToShow(replacedata ? replacedata.length : 0)
          }
        >
          All
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>

    {/* Button */}
    <button
      className="btn btn-success"
      onClick={handleDownload}
      style={{
        backgroundColor: '#d86f89',
        borderColor: '#d86f89',
        color: 'black',
      }}
    >
      Download
    </button>
  </div>
</Row>


                  </CardHeader>
                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                      <tr style={{ textAlign: "center" }}>
                        <th
                          style={{
                            fontSize: "14px",
                            color: "black",
                            fontWeight: "700",
                          }}
                          scope="col"
                        >
                          {" "}
                          Sl.No{" "}
                        </th>
                        <th
                          style={{
                            fontSize: "14px",
                            color: "black",
                            fontWeight: "700",
                          }}
                          scope="col"
                        >
                          {" "}
                          Replaced Items
                        </th>
                        <th
                          style={{
                            fontSize: "14px",
                            color: "black",
                            fontWeight: "700",
                          }}
                          scope="col"
                        >
                          {" "}
                          Cost Spent
                        </th>
                        <th
                          style={{
                            fontSize: "14px",
                            color: "black",
                            fontWeight: "700",
                          }}
                          scope="col"
                        >
                          {" "}
                          Waste Income{" "}
                        </th>
                        <th
                          style={{
                            fontSize: "14px",
                            color: "black",
                            fontWeight: "700",
                          }}
                          scope="col"
                        >
                          {" "}
                          View{" "}
                        </th>
                        <th
                          style={{
                            fontSize: "14px",
                            color: "black",
                            fontWeight: "700",
                          }}
                          scope="col"
                        >
                          {" "}
                          Delete{" "}
                        </th>
                      </tr>
                    </thead>
                    <tbody style={{ textAlign: "center" }}>
                      {filteredReplaceData.length === 0 ? (
                        <tr>
                          <td colSpan={6} style={{ color: "black", fontWeight: "bold" }}>
                            Replacement item not found
                          </td>
                        </tr>
                      ) : (
                        filteredReplaceData
                          .slice(
                            (currentPage - 1) * entriesToShow,
                            currentPage * entriesToShow
                          )
                          .map((item, index) => (
                            <tr key={index}>
                              <th
                                style={{
                                  fontSize: "14px",
                                  color: "black",
                                  fontWeight: "700",
                                }}
                                scope="row"
                              >
                                {++index}
                              </th>
                              <td>{item.replace_item_name}</td>
                              <td>{item.cost}</td>
                              <td>{item.revenue_generated}</td>
                              <td
                                onClick={() => {
                                  setViewProjectName(item);
                                  setShowViewConfirmation(true);
                                }}
                              >
                                <Tippy content="View Details" placement="top">
                                  <span><i className="fas fa-eye text-primary"></i></span>
                                </Tippy>
                              </td>
                              <td
                                onClick={() => {
                                  setDeleteProjectName(item.replace_id);
                                  setShowDeleteConfirmation(true);
                                }}
                              >
                                <Tippy content="Delete Item" placement="top">
                                  <span><i className="fas fa-trash text-danger"></i></span>
                                </Tippy>
                              </td>
                            </tr>
                          ))
                      )}
                    </tbody>
                  </Table>

                  <nav className="mt-3">
                    <ul className="pagination justify-content-center ">
                      <li className="page-item ">
                        <a
                          href="#"
                          className="page-link"
                          style={{ color: 'black', backgroundColor: 'transparent', border: 'none' }}
                          onClick={prePage}
                        >
                          Prev
                        </a>
                      </li>
                      {[currentPage - 1, currentPage, currentPage + 1].map(
                        (pageNumber) => {
                          if (
                            pageNumber > 0 &&
                              pageNumber <=
                                Math.ceil(allData.length / entriesToShow)
                          ) {
                            return (
                              <li key={pageNumber} className="page-item">
                                <a
                                  href="#"
                                  className={`page-link ${pageNumber === currentPage ? "active" : ""}`}
                                  style={{
                                    backgroundColor: pageNumber === currentPage ? 'black' : 'transparent',
                                    color: pageNumber === currentPage ? 'white' : 'black',
                                    border: 'none'
                                  }}
                                  onClick={() => changeCPage(pageNumber)}
                                >
                                  {pageNumber}
                                </a>
                              </li>
                            );
                          }
                          return null;
                        }
                      )}
                      <li className="page-item">
                        <a
                          href="#"
                          className="page-link"
                          style={{ color: 'black', backgroundColor: 'transparent', border: 'none' }}
                          onClick={nextPage}
                        >
                          Next
                        </a>
                      </li>
                    </ul>
                  </nav>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </React.Fragment>

        <Row className="mt-5">
          <Col className="mb-5 mb-xl-0" xl="12" style={{ marginTop: "-20px" }}>
            <Card className="" style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px' }}>
              <CardBody>
                <CardHeader className="border-0">
                  <>
  {/* ✅ Mobile View Layout (Only < md) */}
  <div className="d-block d-md-none">
    {/* Header */}
    <div className="text-center mb-3">
      <h3 className="mb-0 font-bold">Waste Details</h3>
    </div>

    {/* Search Bar */}
    <InputGroup
      className="input-group-alternative mb-3"
      style={{ width: '100%', border: '2px solid #1e3a8a', }}
    >
      <InputGroupAddon addonType="prepend">
        <InputGroupText>
          <i className="fas fa-search" style={{ color: 'black' }} />
        </InputGroupText>
      </InputGroupAddon>
      <Input
        placeholder="Search Waste Items"
        type="text"
        value={searchQueryWaste}
        onChange={(e) => setSearchQueryWaste(e.target.value)}
      />
    </InputGroup>

    {/* Dropdown */}
    <Dropdown
      isOpen={projectDropdownOpen1}
      toggle={toggleProjectDropdown1}
    >
      <DropdownToggle caret className="w-100 text-left p-2" style={{ fontSize: '14px' }}>
        Show Entries:{" "}
        {entriesToShow1 === (wastedata ? wastedata.length : 0)
          ? "All"
          : entriesToShow1}
      </DropdownToggle>
      <DropdownMenu className="w-100">
        <DropdownItem onClick={() => setEntriesToShow1(5)}>5</DropdownItem>
        <DropdownItem onClick={() => setEntriesToShow1(10)}>10</DropdownItem>
        <DropdownItem onClick={() => setEntriesToShow1(wastedata ? wastedata.length : 0)}>All</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>

  {/* ✅ Tablet and Larger (md and up) - Original layout unchanged */}
  <Row className="align-items-center d-none d-md-flex">
    <div className="col">
      <h3 className="mb-0 font-bold">Waste Details</h3>
    </div>
    <div className="col text-right d-flex justify-content-end align-items-center">
      {/* Search Bar */}
      <InputGroup
        className="input-group-alternative mr-3"
        style={{ width: 220, border: '2px solid #1e3a8a', }}
      >
        <InputGroupAddon addonType="prepend">
          <InputGroupText>
            <i className="fas fa-search" style={{ color: 'black' }} />
          </InputGroupText>
        </InputGroupAddon>
        <Input
          placeholder="Search Waste Items"
          type="text"
          value={searchQueryWaste}
          onChange={(e) => setSearchQueryWaste(e.target.value)}
        />
      </InputGroup>

      {/* Dropdown */}
      <Dropdown
        isOpen={projectDropdownOpen1}
        toggle={toggleProjectDropdown1}
      >
        <DropdownToggle caret>
          Show Entries:{" "}
          {entriesToShow1 === (wastedata ? wastedata.length : 0)
            ? "All"
            : entriesToShow1}
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={() => setEntriesToShow1(5)}>5</DropdownItem>
          <DropdownItem onClick={() => setEntriesToShow1(10)}>10</DropdownItem>
          <DropdownItem onClick={() => setEntriesToShow1(wastedata ? wastedata.length : 0)}>All</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  </Row>
</>

                </CardHeader>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th
                        style={{
                          fontSize: "14px",
                          color: "black",
                          fontWeight: "700",
                        }}
                        scope="col"
                      >
                        SL NO
                      </th>
                      <th
                        style={{
                          fontSize: "14px",
                          color: "black",
                          fontWeight: "700",
                        }}
                        scope="col"
                      >
                        Waste Items
                      </th>
                      <th
                        style={{
                          fontSize: "14px",
                          color: "black",
                          fontWeight: "700",
                        }}
                        scope="col"
                      >
                        View
                      </th>
                      <th
                        style={{
                          fontSize: "14px",
                          color: "black",
                          fontWeight: "700",
                        }}
                        scope="col"
                      >
                        Detele
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredWasteData.length === 0 ? (
                      <tr>
                        <td colSpan={4} style={{ color: "black", fontWeight: "bold" }}>
                          Waste item not found
                        </td>
                      </tr>
                    ) : (
                      filteredWasteData
                        .slice(
                          (currentPage1 - 1) * entriesToShow1,
                          currentPage1 * entriesToShow1
                        )
                        .map((item, index) => (
                          <tr key={index}>
                            <th
                              style={{
                                fontSize: "14px",
                                color: "black",
                                fontWeight: "700",
                              }}
                              scope="row"
                            >
                              {++index}
                            </th>
                            <td>{item.item_name}</td>

                            <td
                              onClick={() => {
                                setView1ProjectName(item);
                                setShowView1Confirmation(true);
                              }}
                            >
                              <Tippy content="View Details" placement="top">
                                <span><i className="fas fa-eye text-primary"></i></span>
                              </Tippy>
                            </td>
                            <td
                              onClick={() => {
                                setwastedelete(item.waste_id);
                                setShowDelete1Confirmation(true);
                              }}
                            >
                              <Tippy content="Delete Item" placement="top">
                                <span><i className="fas fa-trash text-danger"></i></span>
                              </Tippy>
                            </td>
                          </tr>
                        ))
                    )}
                  </tbody>
                </Table>
                <nav className="mt-3">
                  <ul className="pagination justify-content-center ">
                    <li className="page-item ">
                      <a
                        href="#"
                        className="page-link"
                        style={{ color: 'black', backgroundColor: 'transparent', border: 'none' }}
                        onClick={prePage1}
                      >
                        Prev
                      </a>
                    </li>
                    {[currentPage - 1, currentPage, currentPage + 1].map(
                      (pageNumber) => {
                        if (
                          pageNumber > 0 &&
                            pageNumber <=
                              Math.ceil(allData1.length / entriesToShow)
                        ) {
                          // Check if pageNumber is within valid range
                          return (
                            <li key={pageNumber} className="page-item">
                              <a
                                href="#"
                                className={`page-link ${pageNumber === currentPage ? "active" : ""}`}
                                style={{
                                  backgroundColor: pageNumber === currentPage ? 'black' : 'transparent',
                                  color: pageNumber === currentPage ? 'white' : 'black',
                                  border: 'none'
                                }}
                                onClick={() => changeCPage1(pageNumber)}
                              >
                                {pageNumber}
                              </a>
                            </li>
                          );
                        }
                        return null; // If pageNumber is out of range, return null
                      }
                    )}
                    <li className="page-item">
                      <a
                        href="#"
                        className="page-link"
                        style={{ color: 'black', backgroundColor: 'transparent', border: 'none' }}
                        onClick={nextPage1}
                      >
                        Next
                      </a>
                    </li>
                  </ul>
                </nav>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Add New Maintainance and its modal */}

      {/* Maintainance Record Table */}

      <Modal
        isOpen={showDeleteConfirmation}
        toggle={() => setShowDeleteConfirmation(false)}
      >
        <ModalHeader>Confirm Deletion</ModalHeader>
        <ModalBody>
          Are you sure you want to delete this material?
        </ModalBody>
        <div className="modal-footer">
          <Button color="danger" onClick={handleDeleteConfirmation}>
            Yes
          </Button>
          <Button
            color="secondary"
            onClick={() => setShowDeleteConfirmation(false)}
          >
            No
          </Button>
        </div>
      </Modal>
      <Modal
        isOpen={showViewConfirmation}
        toggle={() => setShowViewConfirmation(false)}
      >
        <ModalHeader
          toggle={() => setShowViewConfirmation(false)}
          className="pb-0 mt-1"
        >
          <hi>View Replacement Details</hi>
        </ModalHeader>
        <ModalBody>
          {/* Are you sure you want to View this "{ViewProjectName}"? */}
          <div className="row ">
            <div className="col-md-12">
              <div className="form-group">
                <h2>Item Name : {ViewProjectName.replace_item_name}</h2>
              </div>
              <div className="form-group">
                <h2>COST SPENT : {ViewProjectName.cost}</h2>
              </div>
              <div className="form-group">
                <h2>WASTE INCOME: {ViewProjectName.revenue_generated}</h2>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <h2>Old Image : </h2>
                <div
                  style={{
                    borderRadius: "20px",
                    border: "1px solid black",
                    width: "210px",
                    height: "102px",
                  }}
                >
                  {ViewProjectName.replace_item_image && (
                    <img
                      style={{
                        width: "208px",
                        height: "100px",
                        borderRadius: "20px",
                      }}
                      alt="Reversed Image"
                      src={
                        ViewProjectName.replace_item_image
                          ? `/images/${decodeURIComponent(ViewProjectName.replace_item_image)}`
                          : '/images/default-profile.png'
                      }
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="form-group">
                <h2>New Image : </h2>
                <div
                  style={{
                    borderRadius: "20px",
                    border: "1px solid black",
                    width: "210px",
                    height: "102px",
                  }}
                >
                  {ViewProjectName.new_item_image && (
                    <img
                      style={{
                        width: "208px",
                        height: "100px",
                        borderRadius: "20px",
                      }}
                      alt="Reversed Image"
                      src={require(`../../../images/${ViewProjectName.new_item_image}`)}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={showView1Confirmation}
        toggle={() => setShowView1Confirmation(false)}
      >
        <ModalHeader
          toggle={() => setShowView1Confirmation(false)}
          className="pb-0 mt-1"
        >
          <h2>VIEW WASTE ITEM</h2>
        </ModalHeader>
        <ModalBody>
          <div className="row ">
            <div className="col-md-12">
              <div className="form-group">
                <h3>Item Name : {View1ProjectName.item_name}</h3>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="form-group">
                <div>
                  <h3>Image : </h3>
                  {View1ProjectName.image && (
                    <img
                      style={{
                        width: "417px",
                        height: "198px",
                        borderRadius: "20px",
                        borderRadius: "20px",
                        border: "1px solid black",
                      }}
                      alt="Reversed Image"
                      src={require(`../../../images/${View1ProjectName.image}`)}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={showDelete1Confirmation}
        toggle={() => setShowDelete1Confirmation(false)}
      >
        <ModalHeader>Confirm Deletion</ModalHeader>
        <ModalBody>Are you sure you to delete this material?</ModalBody>
        <div className="modal-footer">
          <Button color="danger" onClick={handleDelete1Confirmation}>
            Yes
          </Button>
          <Button
            color="secondary"
            onClick={() => setShowDelete1Confirmation(false)}
          >
            No
          </Button>
        </div>
      </Modal>

      {/* Success Alert Modal */}
      {showSuccessAlert && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
          justifyContent: 'center', alignItems: 'flex-start', paddingTop: '15%', zIndex: 9999
        }}>
          <div style={{
            backgroundColor: '#fff', padding: '30px', borderRadius: '15px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.3)', textAlign: 'center',
            maxWidth: '400px', width: '90%', border: '3px solid #d86f89'
          }}>
            <div style={{ fontSize: '48px', color: '#d86f89', marginBottom: '20px' }}>✓</div>
            <h4 style={{ color: '#28a745', marginBottom: '15px' }}>Success!</h4>
            <p style={{ color: '#333', fontSize: '16px', marginBottom: '20px' }}>{successMessage}</p>
            <Button
              style={{
                backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'white',
                padding: '10px 25px', borderRadius: '25px'
              }}
              onClick={() => { setShowSuccessAlert(false); window.location.reload(); }}
            >OK</Button>
          </div>
        </div>
      )}

      {/* Error Alert Modal */}
      {showErrorAlert && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
          justifyContent: 'center', alignItems: 'flex-start', paddingTop: '15%', zIndex: 9999
        }}>
          <div style={{
            backgroundColor: '#fff', padding: '30px', borderRadius: '15px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.3)', textAlign: 'center',
            maxWidth: '400px', width: '90%', border: '3px solid #d86f89'
          }}>
            <div style={{ fontSize: '48px', color: '#d86f89', marginBottom: '20px' }}>!</div>
            <h4 style={{ color: '#d9534f', marginBottom: '15px' }}>Error</h4>
            <p style={{ color: '#333', fontSize: '16px', marginBottom: '20px' }}>{errorMessage}</p>
            <Button
              style={{
                backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'white',
                padding: '10px 25px', borderRadius: '25px'
              }}
              onClick={() => setShowErrorAlert(false)}
            >OK</Button>
          </div>
        </div>
      )}

      {/* Success Alert Modal for Deletion */}
      {showDeleteSuccessAlert && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
          justifyContent: 'center', alignItems: 'flex-start', paddingTop: '15%', zIndex: 9999
        }}>
          <div style={{
            backgroundColor: '#fff', padding: '30px', borderRadius: '15px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.3)', textAlign: 'center',
            maxWidth: '400px', width: '90%', border: '3px solid #d86f89'
          }}>
            <div style={{ fontSize: '48px', color: '#d86f89', marginBottom: '20px' }}>✓</div>
            <h4 style={{ color: '#28a745', marginBottom: '15px' }}>Success!</h4>
            <p style={{ color: '#333', fontSize: '16px', marginBottom: '20px' }}>{deleteSuccessMessage}</p>
            <Button
              style={{
                backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'white',
                padding: '10px 25px', borderRadius: '25px'
              }}
              onClick={() => { setShowDeleteSuccessAlert(false); window.location.reload(); }}
            >OK</Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Wasteage4;
